<template>
  <div class="brand-info clear">
    <div class="brand-img-wrap fl">
      <img class="brand-img" :src="logo" alt="" />
      <!-- 爆炸贴图片 -->
      <!-- <Sticker /> -->
    </div>
    <div class="info fr">
      <p class="brand-name">
        {{ brandName }}
      </p>
      <div class="brand-introduction">
        <span>{{TLang('品牌介绍','my')}}</span>
        <p v-html="brandIntroduction"></p>
      </div>
    </div>

    <div v-if="minPrice != null && minPrice >=0" class="brand-price">
      <span class="fudou-price">
        <img
        class="fudou-icon"
        :src="union_icon || require('@assets/images/fudou.png')"
        alt=""
      />
      <span>{{ (minPrice * union_scale).toFixed(2) }}</span>

      </span>
      
      {{TLang('起','my')}}
    </div>
  </div>
</template>

<script>
import Sticker from "@components/sticker";
export default {
  name: "BrandInfo",
  components: { Sticker },
  props: {
    logo: {
      type: String,
      default: "",
    },
    brandName: {
      type: String,
      default: "",
    },
    brandIntroduction: {
      type: String,
      default: "",
    },
    minPrice: {
      type: Number,
      default: -1,
    },
  },
};
</script>

<style lang="less" scoped>
.brand-info {
  border: 1px solid #ececec;
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  position: relative;
  .brand-img-wrap{
    position: relative;
  }
  .brand-img {
    width: 320px;
    height: 320px;
  }
  .info {
    width: 815px;
  }
  .brand-name {
    font-size: 22px;
    color: #333;
    margin-bottom: 50px;
  }
  .brand-introduction {
    font-size: 14px;
    color: #333;
    line-height: 28px;
    p {
      text-indent: 2em;
    }
  }
  .brand-price {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 14px;
    color: #333;
    display: flex;
    align-items: baseline;
    img {
      width: 24px;
      height: 24px;
    }
    span {
      color: #ff0000;
      font-size: 30px;
      font-weight: 500;
    }
  }
  .fudou-price{
    display: flex;
    align-items: baseline;
  }
}
</style>
